import { SDrawerOrModal, SLowcodeList, SMessage, STableActions } from 'shj-components'
import { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react'
import { useSetState, useUpdateEffect } from 'ahooks'
import config from './config.tsx'
import HouseHoldManege from '../../addQuotationDrawer/step2.tsx'
import ContractModal from '@/components/ContractModal'
import { Button, Input, message, Space } from 'antd'
import { useNavigate, useParams } from 'react-router-dom'
import PriceDetailPopover from '@/pages/orderService/components/PriceDetailPopover.tsx'
import ProgramProcessModal from '@/components/ProgramProcess'
import {
  deleteQuoteBudget,
  getQuoteBudgetList,
  saveHouseInfo,
  updateQuoteBudgetId,
} from '@/services/order.ts'
import { getBudgetPrintInfoMap } from '@/services/goods.ts'
import { getAuth } from '@/utils/btn.ts'
import { getBusinessDictList } from '@/services/product.ts'
import { get } from 'lodash-es'

type IProps = {
  detail: Record<string, any> // 商品详情信息
  reloadDetail: () => void // 刷新商品基础信息
  orderId: string // 订单id
}

const { TextArea } = Input

const QuotaList = forwardRef((props: IProps, ref: any) => {
  const listRef = useRef<any>()
  const houseTypeRef = useRef<any>()
  const { detail, reloadDetail, orderId } = props
  const [state, setState] = useSetState({
    visible: false,
    houseLoading: false,
    record: {},
    tableList: [],
  })
  const [householdOpen, setHouseholdOpen] = useState(false)
  const [priceDeatilOpen, setPriceDeatilOpen] = useState(false)
  const [contractMap, setContractMap] = useState({})
  const [openContractModal, setOpenContractModal] = useState(false)
  const [editRemarkId, setEditRemarkId] = useState('')
  const [editRemarkContent, setEditRemarkContent] = useState('')
  const [openRemarkModal, setOpenRemarkModal] = useState(false)
  const [programProcessModalOpen, setProgramProcessModalOpen] = useState(false) // 方案审核弹窗
  const [showChangeReason, setShowChangeReason] = useState(false)
  const navaigate = useNavigate()
  const priceDetailRef = useRef<any>()
  const auths = getAuth() || {}

  useImperativeHandle(ref, () => {
    return {
      reload: () => listRef.current.reload(),
      reset: () => listRef.current.reset(),
      data: state.tableList,
    }
  }, [listRef.current])
  // 根据公司判断是否展示“变更原因”列
  useEffect(() => {
    const resolveShow = async () => {
      try {
        const res = await getBusinessDictList({ data: { priKey: 'startWorkAfterChooseSpecialOrgIds', enabled: true } })
        const raw = String(get(res, '[0].children[0].object.dataValue', '')).trim()
        const idSet = new Set(
          raw
            .split(',')
            .map(s => s.trim())
            .filter(Boolean)
        )
        console.log(detail?.orgId, '变更原因')
        const companyId = String(detail?.orgId ?? '').trim()
        setShowChangeReason(idSet.has(companyId))
      } catch (e) {
        setShowChangeReason(false)
      }
    }
    resolveShow()
  }, [])

  useUpdateEffect(() => {
    listRef.current.reload()
  }, [detail])

  const fetchList = () => {
    console.log(detail, '商品detail')
    return new Promise((resolve, reject) => {
      if (detail) {
        try {
          getQuoteBudgetList({ data: { quoteGoodsId: detail.id } }).then((res: any) => {
            console.log(res, 'res')
            setState({ tableList: res })
            resolve({
              records: res || [],
            })
          })
        } catch {
          reject({ success: false })
        }
      } else {
        reject({ success: false })
      }
    })
  }

  const onDelete = id => {
    SMessage.confirm({
      onOk: () => {
        if (id) {
          deleteQuoteBudget({ params: { id } }).then(() => {
            message.success('删除成功')
            listRef.current?.reload()
            reloadDetail()
          })
        }
      },
    })
  }
  // 选材
  const clickToSelect = record => {
    console.log(record, 'record')
    let version = localStorage.getItem('versionChange')
    if (record.type === 'bidProjectMCContract') {
      // 缺断货选材
      navaigate(`/order/list/details/shortageGoods/${record.id}?orderState=${detail.orderState}`)
    } else if (detail.capitalQuoteFlag) {
      // 软装选材
      navaigate(
        `/order/list/details/pooling-quote-selection/${record.id}?orderState=${detail.orderState}`
      )
    } else {
      if (version && version === 'new') {
        navaigate(
          `/order/list/details/quote-space-selection/${record.id}?orderState=${detail.orderState}&orderId=${orderId}`
        )
      } else {
        navaigate(
          `/order/list/details/quote-selection/${record.id}?orderState=${detail.orderState}&orderId=${orderId}`
        )
      }
    }
  }
  // 发起合同
  const clickToContract = async record => {
    try {
      if (record) {
        const res = await getBudgetPrintInfoMap([record])
        setContractMap(res || {})
        setOpenContractModal(true)
      } else {
        message.error('无报价ID')
      }
    } catch (err) {}
  }
  // 户型管理
  const clickToHouseholdManage = record => {
    setHouseholdOpen(true)
    setState({ record })
  }
  // 价格明细
  const clickToPriceDetail = record => {
    setPriceDeatilOpen(true)
    priceDetailRef?.current?.reset(record.id)
    priceDetailRef?.current?.setOperate(record?.state === 'budgetDraft' && !record?.frozenFlag)
  }

  const updateRemark = (record: any) => {
    setEditRemarkId(record?.id)
    setEditRemarkContent(record?.description || '')
    setOpenRemarkModal(true)
  }

  const handleSaveRemark = async () => {
    try {
      const res = await updateQuoteBudgetId({
        id: editRemarkId,
        description: editRemarkContent,
      })
      if (res?.id) {
        setOpenRemarkModal(false)
        message.success('修改备注成功')
        listRef.current.reload()
      }
    } catch (err) {
      console.log(err)
    }
  }

  const openProgramProcess = (record: any) => {
    setState({ record })
    setProgramProcessModalOpen(true)
  }

  // 按钮显示渲染控制
  const handleOperation = record => {
    const bizTag = '整装'
    console.log(record)
    const couldOperate = record?.state === 'budgetDraft' && !record?.frozenFlag

    return (
      <STableActions>
        <STableActions.SActionBtn onClick={() => clickToSelect(record)}>
          预算详情
        </STableActions.SActionBtn>
        {record.type !== 'bidProjectMCContract' && (
          <STableActions.SActionBtn onClick={() => clickToPriceDetail(record)}>
            价格明细
          </STableActions.SActionBtn>
        )}

        {record?.diagramReviewFlag ? (
          <STableActions.SActionBtn
            disabled={record?.frozenFlag}
            onClick={() => openProgramProcess(record)}
          >
            发起方案审核
          </STableActions.SActionBtn>
        ) : null}

        {auths['starting_contract'] && (
          <STableActions.SActionBtn onClick={() => clickToContract(record.id)}>
            发起合同
          </STableActions.SActionBtn>
        )}

        <STableActions.SActionBtn onClick={() => updateRemark(record)}>
          修改备注
        </STableActions.SActionBtn>

        {/*预算报价类型且非定制需求展示按钮*/}
        {record.type === 'bidMainContract' &&
          record.bizTag !== 'productTypeCustomizePackage' &&
          record.type !== 'bidProjectMCContract' && (
            <STableActions.SActionBtn
              // disabled={!couldOperate}
              onClick={() => clickToHouseholdManage(record)}
            >
              户型管理
            </STableActions.SActionBtn>
          )}
        {
          <STableActions.SActionBtn
            disabled={!couldOperate}
            danger
            confirm
            title="确认删除?"
            onClick={() => onDelete(record.id)}
          >
            删除
          </STableActions.SActionBtn>
        }
      </STableActions>
    )
  }

  const extensions = {
    request: { fetchList },
    customRender: {
      operation(_, record: Record<string, any>) {
        return handleOperation(record)
      },
    },
  }

  // 价格明细
  const detailData = [
    {
      price: 88,
      title: '商品总价',
      edit: false,
    },
    {
      title: '运费',
      edit: false,
      price: 99,
    },
    {
      title: '运费险',
      edit: false,
      price: 19,
    },
    {
      title: '运费险',
      edit: false,
      price: 19,
    },
    {
      title: '减项金额',
      edit: true,
      price: 19,
    },
  ]
  const priceDetailItem = [
    {
      key: '1',
      label: (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div>销售指导价</div>
          <div>123412</div>
        </div>
      ),
      children: (
        <Space direction="vertical" size="small" style={{ display: 'flex' }}>
          {detailData.map((item, index) => {
            return (
              <div style={{ display: 'flex', justifyContent: 'space-between', paddingLeft: 24 }}>
                <p>{item.title}</p>
                <p style={{ display: 'flex', alignItems: 'center' }}>
                  <span>￥</span>
                  {item.edit ? (
                    <Input style={{ width: 100 }} size="small" value={item.price}></Input>
                  ) : (
                    item.price
                  )}
                </p>
              </div>
            )
          })}
        </Space>
      ),
    },
  ]

  const onSaveHouseType = () => {
    const spaceBudgetItemList = houseTypeRef.current?.data || []
    const notShowName = spaceBudgetItemList.some(item => !item.showName)
    if (notShowName) return message.error('显示名称不能为空')
    setState({ houseLoading: true })
    saveHouseInfo({
      data: spaceBudgetItemList?.map((item: any, index: number) => {
        return { ...item, sort: index + 1 }
      }),
    })
      .then(res => {
        message.success(res.message || '操作成功')
        setHouseholdOpen(false)
        setState({ record: {} })
      })
      .finally(() => setState({ houseLoading: false }))
  }

  const mergedConfig = useMemo(() => {
    const cols = (config.columns || []).filter((col: any) => showChangeReason || col?.dataIndex !== 'changeReasonStr')
    return { ...config, columns: cols }
  }, [showChangeReason])

  return (
    <>
      <SLowcodeList searchMode={'group'} ref={listRef} config={mergedConfig} {...extensions} />
      <SDrawerOrModal
        mode="drawer"
        open={householdOpen}
        title="户型管理"
        onCancel={() => setHouseholdOpen(false)}
        antdProps={{
          footer: [
            <Button
              key="cancel"
              onClick={() => setHouseholdOpen(false)}
              style={{ marginRight: 10 }}
            >
              取消
            </Button>,
            <Button
              key="save"
              type="primary"
              loading={state.houseLoading}
              onClick={onSaveHouseType}
            >
              保存
            </Button>,
          ],
        }}
        // onOk={onSaveHouseType}
      >
        {householdOpen && (
          <HouseHoldManege
            ref={houseTypeRef}
            isEdit={true}
            // couldOperate={state.record?.state === 'budgetDraft' && !state.record?.frozenFlag}
            detailInfo={state.record}
            query={{ quoteBudgetId: state.record?.id }}
          />
        )}
      </SDrawerOrModal>

      {/* 价格明细 */}
      <SDrawerOrModal
        mode="modal"
        open={priceDeatilOpen}
        title="价格明细"
        onCancel={() => setPriceDeatilOpen(false)}
        width={400}
        antdProps={{ footer: false, destroyOnClose: true }}
      >
        <PriceDetailPopover
          open={priceDeatilOpen}
          mode={'card'}
          ref={priceDetailRef}
          onCancel={() => setPriceDeatilOpen(false)}
          reloadList={() => {
            listRef.current?.reload()
            reloadDetail()
          }}
        ></PriceDetailPopover>
        {/*<Collapse defaultActiveKey={['1']} ghost items={priceDetailItem} style={{ width: 450 }} />*/}
      </SDrawerOrModal>
      {openContractModal && (
        <ContractModal
          open={openContractModal}
          closeDialog={() => setOpenContractModal(false)}
          contractMap={contractMap}
        />
      )}
      {openRemarkModal && (
        <SDrawerOrModal
          mode="modal"
          open={openRemarkModal}
          title="修改备注"
          onCancel={() => setOpenRemarkModal(false)}
          onOk={handleSaveRemark}
          width={400}
        >
          <TextArea
            value={editRemarkContent}
            onChange={(e: any) => setEditRemarkContent(e?.target?.value || '')}
            rows={4}
            placeholder="请输入备注"
            maxLength={255}
            showCount
          />
        </SDrawerOrModal>
      )}
      {programProcessModalOpen && (
        <ProgramProcessModal
          title="发起方案审核"
          quoteId={state.record?.id || ''}
          setOpen={setProgramProcessModalOpen}
          open={programProcessModalOpen}
          reload={() => listRef.current.reload()}
        />
      )}
    </>
  )
})
export default QuotaList
